import { Fancybox, Panzoom } from '../plugins/FancyboxPlugin.js';
import '../plugins/TinySmoothScrollPlugin.js';
import imagesLoaded from '../plugins/ImageLoadedPlugin.js';
import gsap from "gsap";

window.Fancybox = Fancybox;
window.Panzoom = Panzoom;


// Fancybox init
export default function initFancybox() {
	const isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
	const $html = jQuery('html');
	const $win = jQuery(window);

	jQuery('.js-inner-fancybox').each((i, holder) => {
		if (!holder.id) {
			holder.id = `js-inner-fancybox-${i}`;
		}

		let mouseInactiveTimeout = null;
		const hideDuration = 5000;
		const mouseInactiveClass = 'mouse-inactive';

		Fancybox.bind(`#${holder.id} .js-fb-gallery[data-fancybox]`, {
			mainClass: 'fullscreen-gallery-modal',
			// hideScrollbar: false,
			dragToClose: false,
			placeFocusBack: false,
			// parentEl: holder,
			Thumbs: false,
			Hash: false,
			template: {
				// Close button icon
				closeButton: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg>',
				// Loading indicator icon
				spinner: '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="25 25 50 50" tabindex="-1"><circle cx="50" cy="50" r="20"/></svg>',
				// Main container element
				main: null,
			},
			Toolbar: {
				display: [
					{ id: "counter", position: "right" },
					{ id: "zoomOut", position: "center" },
					{ id: "zoomRange", position: "center" },
					{ id: "zoomIn", position: "center" },
					{ id: "close", position: "right" }
				],
				items: {
					close: {
						type: "button",
						label: "CLOSE",
						class: "fancybox__button--close",
						html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M317.7 402.3c3.125 3.125 3.125 8.188 0 11.31c-3.127 3.127-8.186 3.127-11.31 0L160 267.3l-146.3 146.3c-3.127 3.127-8.186 3.127-11.31 0c-3.125-3.125-3.125-8.188 0-11.31L148.7 256L2.344 109.7c-3.125-3.125-3.125-8.188 0-11.31s8.188-3.125 11.31 0L160 244.7l146.3-146.3c3.125-3.125 8.188-3.125 11.31 0s3.125 8.188 0 11.31L171.3 256L317.7 402.3z"/></svg>',
						tabindex: 1,
						click: function(event) {
							event.stopPropagation();
							event.preventDefault();

							this.fancybox.close();
						},
					},
					counter: {
						type: "div",
						class: "fancybox__counter",
						html: '<span data-fancybox-index=""></span>/<span data-fancybox-count=""></span>',
						tabindex: -1,
					},
					zoomOut: {
						type: "button",
						class: "fancybox__button--zoomOut",
						label: "Zoom in",
						html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 256C432 264.8 424.8 272 416 272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h384C424.8 240 432 247.2 432 256z"/></svg>',
						click: function(event) {
							event.preventDefault();

							const panzoom = this.fancybox.getSlide().Panzoom;

							if (panzoom) {
								panzoom.zoomOut();
							}
						},
					},
					zoomIn: {
						type: "button",
						class: "fancybox__button--zoomIn",
						label: "Zoom in",
						html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 256C432 264.8 424.8 272 416 272h-176V448c0 8.844-7.156 16.01-16 16.01S208 456.8 208 448V272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h176V64c0-8.844 7.156-15.99 16-15.99S240 55.16 240 64v176H416C424.8 240 432 247.2 432 256z"/></svg>',
						click: function(event) {
							event.preventDefault();

							const panzoom = this.fancybox.getSlide().Panzoom;

							if (panzoom) {
								panzoom.zoomIn();
							}
						},
					},
					zoomRange: {
						type: "div",
						class: "fancybox__zoomRange",
						label: "Zoom range",
						html: '<input type="range" value="1" min="0.5" max="3" step="0.1"/>'
					}
				}
			},
			Image: {
				Panzoom: {
					baseScale: 1,
					minScale: 0.5,
					maxScale: (self) => {
						return 3
				        // return self.content.origWidth > 0 && self.content.fitWidth > 0
				        //   ? self.content.origWidth / self.content.fitWidth
				        //   : maxScale;
				      },
					step: 0.5,
					// wheelFactor: 22,
					// wheelLimit: 6,
					// zoomFriction: 0.2,
					click: 'toggleZoom',
					zoomInCentered: true
				},
			},
			Carousel: {
				Navigation: {
					prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M172.9 432.2L2.355 261.7c-3.14-3.14-3.14-8.226 0-11.37l170.5-170.5c3.14-3.14 8.226-3.14 11.37 0s3.14 8.226 0 11.37L27.44 247.1h412.5c4.427 0 8.036 3.597 8.036 8.04s-3.61 8.035-8.036 8.035H27.44l156.8 156.8c3.14 3.14 3.14 8.226 0 11.37C181.1 435.3 175.1 435.3 172.9 432.2z"/></svg>',
					nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M275.1 79.82l170.5 170.5c3.14 3.14 3.14 8.226 0 11.37l-170.5 170.5c-3.14 3.14-8.226 3.14-11.37 0c-3.14-3.14-3.14-8.226 0-11.37l156.8-156.8H8.037c-4.427 0-8.036-3.593-8.036-8.036s3.609-8.039 8.036-8.039h412.5l-156.8-156.8c-3.14-3.14-3.14-8.226 0-11.37C266.9 76.68 272 76.68 275.1 79.82z"/></svg>',
				}
			},
			on: {
				"Image.afterUpdate": (fancybox, slide) => {
					const toolbar = fancybox.plugins.Toolbar;
					const panzoom = slide.Panzoom;
					const $zoomRange = jQuery(toolbar.$container).find('.fancybox__zoomRange input');

					if (panzoom) {
						// const maxVal = Math.round(panzoom.content.origWidth/panzoom.content.fitWidth*2)/2;
						// $zoomRange.attr('max', maxVal).prop('max', maxVal).val(panzoom.transform.scale);
						
						// if (maxVal < 1.1) {
						// 	fancybox.$container.classList.add('disable-zoom');
						// } else {
						// 	fancybox.$container.classList.remove('disable-zoom');
						// }
					}

				},
				"Image.startAnimation": (fancybox, slide) => {
					const toolbar = fancybox.plugins.Toolbar;
					const panzoom = slide.Panzoom;
					const $zoomRange = jQuery(toolbar.$container).find('.fancybox__zoomRange input');

					if (panzoom) {
						// const maxVal = Math.round(panzoom.content.origWidth/panzoom.content.fitWidth*2)/2;
						// $zoomRange.attr('max', maxVal).prop('max', maxVal).val(panzoom.transform.scale);

						// if (maxVal < 1.1) {
						// 	fancybox.$container.classList.add('disable-zoom');
						// } else {
						// 	fancybox.$container.classList.remove('disable-zoom');
						// }
					}

				},
				"Image.endAnimation": (fancybox, slide) => {
					const toolbar = fancybox.plugins.Toolbar;
					const panzoom = slide.Panzoom;
					const $zoomRange = jQuery(toolbar.$container).find('.fancybox__zoomRange input');

					if (panzoom) {
						// const maxVal = Math.round(panzoom.content.origWidth/panzoom.content.fitWidth*2)/2;
						// $zoomRange.attr('max', maxVal).prop('max', maxVal).val(panzoom.transform.scale);

						// if (maxVal < 1.1) {
						// 	fancybox.$container.classList.add('disable-zoom');
						// } else {
						// 	fancybox.$container.classList.remove('disable-zoom');
						// }

						$zoomRange.val(panzoom.transform.scale);
					}
				},
				load: (fancybox, slide) => {
					$html.addClass('fullscreen-gallery-loaded');
					fancybox.options.$trigger.classList.add('current-fullscreen-gallery-trigger');

					window.TinySmoothScroll && TinySmoothScroll(jQuery(holder).offset().top, ('scrollBehavior' in document.documentElement.style) ? 0 : 600);
					
					jQuery(document).on('mousemove', mousemoveHandler);

					mousemoveHandler();
				},

				reveal: (fancybox, slide) => {
					const toolbar = fancybox.plugins.Toolbar;
					const panzoom = slide.Panzoom;
					const $zoomRange = jQuery(toolbar.$container).find('.fancybox__zoomRange input');

					if (panzoom) {
						$zoomRange.on('click keyup', e => {
							e.stopImmediatePropagation();
						}).on('change input', e => {
							fancybox.getSlide().Panzoom.zoomTo(+e.currentTarget.value);
						});
					}
				},

				shouldClose: (fancybox, slide) => {
					$html.removeClass('fullscreen-gallery-loaded');
					fancybox.options.$trigger.classList.remove('current-fullscreen-gallery-trigger');
					jQuery(document).off('mousemove', mousemoveHandler);
					clearTimeout(mouseInactiveTimeout);
				},
			},
		});
		
		function mousemoveHandler() {
			$html.removeClass(mouseInactiveClass);

			clearTimeout(mouseInactiveTimeout);
			mouseInactiveTimeout = setTimeout(() => {
				$html.addClass(mouseInactiveClass);
			}, hideDuration);
		}
	});


	jQuery('img.js-zoom-image').each((i, img) => {
		const parent = img.closest('.js-inner-fancybox') || img.parentNode;

		if (!isTouchDevice) {
			imageMoving(img, parent);
			imagesLoaded(parent, () => {
				$win.trigger('zoom-image-loaded');
			});
		} else {
      let $galleryHolder = $('.js-fb-gallery-holder');
      $galleryHolder.css('opacity', 1);
    }
	});


	function imageMoving(image, holder) {
		// Acceleration value between 0 and 1
		// Smaller values result in a slower/smoother looking animation
		let acceleration = +image.dataset.acceleration || 0.05;

    let $galleryHolder = $('.js-fb-gallery-holder');

    let focalPointX = $galleryHolder.data('focalPointX') || 0;
    let focalPointY = $galleryHolder.data('focalPointY') || 0;
    if (focalPointX === 0.5) {
      focalPointX = 0;
    }
    if (focalPointY === 0.5) {
      focalPointY = 0;
    }

    let tween = null;
		let timer = null;

		const img = {
			element: image,
			xMax: 0,
			yMax: 0,
			x: 0,
			y: 0
		};

		let mouse = { x: 0, y: 0 };

		let vw = 0;
		let vh = 0;

		function init() {
			resize();

			gsap.set(img.element, { x: 0, y: 0 });

			let pos = gsap.getProperty(img.element);

      var movingAllowed = false;
      setTimeout(function () {
        movingAllowed = true;
      }, 2500);

      tween = gsap.to(img.element, {
				x: 0,
				y: 0,
				repeat: -1,
				ease: 'none',
        onStart: function () {
          setTimeout(function () {
            $galleryHolder.css('opacity', 1);
          }, 200);
        },
				modifiers: {
					x: function() {
            var currentX = movingAllowed ? mouse.x : vw * focalPointX;
            var currentAcceleration = movingAllowed ? acceleration : 1;
						img.x = map(currentX, 0, vw, 0, img.xMax);
						return Math.max(img.xMax, pos('x') + (img.x - pos('x')) * currentAcceleration) + 'px';
					},
					y: function() {
            var menuOffset = 80;
            var currentVh = Math.max((vh - menuOffset), 0);
            var currentY = movingAllowed ? Math.max((mouse.y - menuOffset), 0) : (currentVh * focalPointY);
            var currentAcceleration = movingAllowed ? acceleration : 1;
            img.y = map(currentY, 0, currentVh, 0, img.yMax);
            return Math.max(img.yMax, pos('y') + (img.y - pos('y')) * currentAcceleration) + 'px';
					}
				}
			});

			(holder || document.documentElement).addEventListener("mouseenter", () => {
				window.addEventListener("mousemove", moveAction);
			});

			(holder || document.documentElement).addEventListener("mouseleave", () => {
				window.removeEventListener("mousemove", moveAction);
			});

			$win.on('load resize zoom-image-loaded', resize);
		}

		function map(x, a, b, c, d) {
			return c + (d - c) * ((x - a) / (b - a)) || 0;
		}

		function resize() {
			clearTimeout(timer);

			if (tween) {
				tween.pause(0, false);
			}

			timer = setTimeout(() => {
				vw = holder ? holder.clientWidth : window.innerWidth;
				vh = holder ? holder.clientHeight : window.innerHeight;
				img.xMax = Math.min(0.01, vw - Math.max(img.element.width, img.element.naturalWidth));
				img.yMax = Math.min(0.01, vh - Math.max(img.element.height, img.element.naturalHeight));

				if (tween) {
					tween.play();
				}
			}, 100);
		}

		function moveAction(event) {
			let scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
			if (event.targetTouches && event.targetTouches[0]) {
				event.preventDefault();
				mouse.x = event.targetTouches[0].clientX;
				mouse.y = event.targetTouches[0].clientY + scrollTop;
			} else {
				mouse.x = event.clientX;
				mouse.y = event.clientY + scrollTop;
			}
		}

		init();
	}
}
